import React from 'react';
import { Link } from 'react-router-dom';

interface EntityLinkProps {
  to: string;
  children: React.ReactNode;
  className?: string;
}

export const EntityLink: React.FC<EntityLinkProps> = ({ to, children, className = '' }) => {
  return (
    <Link to={to} className={`text-primary-600 hover:text-primary-700 hover:underline ${className}`}>
      {children}
    </Link>
  );
};
